/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_All_DayInputs */

const en_calendar_all_day = /** @type {(inputs: Calendar_All_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All day`)
};

const pt_br2_calendar_all_day = /** @type {(inputs: Calendar_All_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dia todo`)
};

/**
* | output |
* | --- |
* | "All day" |
*
* @param {Calendar_All_DayInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const calendar_all_day = /** @type {((inputs?: Calendar_All_DayInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_All_DayInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_all_day(inputs)
	return pt_br2_calendar_all_day(inputs)
});